<template>
  <section class="tv-screen masthead">
    <div class="container-fluid">
      <div class="row tv-screen-header py-5 mx-lg-2 align-items-center">
        <div class="col-lg-8">
          <h1>Student Enquiry Form</h1>
        </div>
      </div>
      <!-- NPF div -->
      <div class="row align-items-center justify-content-center">
        <div class="col-md-10" style="height: 700px">
          <div
            style="height: 700px"
            class="npf_wgts"
            data-height="700px"
            data-w="0c81a60057c8f21a50c0f1e6cf563c82"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        course: null,
        specialization: null,
        interestedCountry: "",
        highestQualification: "",
        budget: "",
      },
      stateOptions: [
        { value: null, text: "Select A State *" },
        { value: "a", text: "This is First option" },
      ],
      cityOptions: [
        { value: null, text: "Select A City *" },
        { value: "a", text: "This is First option" },
      ],
      courseOptions: [
        { value: null, text: "Select A Course *" },
        { value: "a", text: "This is First option" },
      ],
      specializationOptions: [
        { value: null, text: "Select A Course *" },
        { value: "a", text: "This is First option" },
      ],
    };
  },
  methods: {
    info() {},
  },
  beforeMount() {},
};
</script>

<style>
.list-inline {
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
}
.list-inline li:not(:first-child):before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 50%;
  margin: 0px 20px;
}
.yottie-widget-feed-section-pagination .swiper-pagination-bullet-active {
  background-color: var(--primary) !important;
  color: #fff !important;
}

.yottie-widget-video-classic {
  border: 2px solid #d0d0d0 !important;
  padding: 10px !important;
  border-radius: 10px !important;
}
span.yottie-widget-feed-section-pagination-bullet {
  height: 40px !important;
  width: 40px !important;
  line-height: 1.6 !important;
  font-size: 18px !important;
}

.custom-input {
  border: none;
  outline: 0 !important;
  border-bottom: 1px solid lightgrey;
  box-shadow: none;
  transition: all 0.5s;
}

.custom-input:focus {
  box-shadow: none !important;
  border-bottom: 1px solid #fe6d01;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/sef.vue